import { render, staticRenderFns } from "./FormEditWiedervorlage.vue?vue&type=template&id=ce2780f0&scoped=true"
import script from "./FormEditWiedervorlage.vue?vue&type=script&lang=js"
export * from "./FormEditWiedervorlage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2780f0",
  null
  
)

export default component.exports